import React, { useState } from 'react';
import client from '../api/client';
import { toISODate } from '../utils/dates';
import { subDays } from 'date-fns';
import DatePicker from '../components/DatePicker';

export default function ExportPage() {
  const [startDate, setStartDate] = useState(toISODate(subDays(new Date(), 30)));
  const [endDate, setEndDate] = useState(toISODate(new Date()));
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const res = await client.get('/export/pdf', {
        params: { startDate, endDate },
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `endotrack-report-${startDate}-to-${endDate}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      alert('Failed to generate PDF. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white drop-shadow-sm">Export Report</h1>
        <p className="text-white/70 mt-1">Generate a PDF report to share with your doctor</p>
      </div>

      <div className="glass rounded-2xl p-6 space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-white/80 mb-1">Start Date</label>
            <DatePicker
              value={startDate}
              max={endDate}
              onChange={setStartDate}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-white/80 mb-1">End Date</label>
            <DatePicker
              value={endDate}
              max={toISODate(new Date())}
              onChange={setEndDate}
            />
          </div>
        </div>

        <div className="bg-white/10 rounded-lg p-4 text-sm text-white/70">
          <p className="font-medium mb-1 text-white/90">The PDF report includes:</p>
          <ul className="list-disc list-inside space-y-1 text-white/60">
            <li>Summary statistics (pain, energy, sleep, stress averages)</li>
            <li>Daily overview table with key metrics</li>
            <li>Detailed entries (moods, GI symptoms, meals, beverages, medications, notes)</li>
            <li>Flare and period day tracking</li>
            <li>AI-generated insights</li>
          </ul>
        </div>

        <button
          onClick={handleExport}
          disabled={loading}
          className="w-full py-3 bg-white text-black rounded-lg font-medium hover:bg-white/90 disabled:opacity-50"
        >
          {loading ? 'Generating PDF...' : 'Download PDF Report'}
        </button>
      </div>
    </div>
  );
}
